__turbopack_context__.v({
  "bgImage": "MembershipCard-module-scss-module__r6URCq__bgImage",
  "bgImageWrapper": "MembershipCard-module-scss-module__r6URCq__bgImageWrapper",
  "calendlyBtn": "MembershipCard-module-scss-module__r6URCq__calendlyBtn",
  "iconPlaceholder": "MembershipCard-module-scss-module__r6URCq__iconPlaceholder",
  "wrapper": "MembershipCard-module-scss-module__r6URCq__wrapper",
});
